import { Chip, cn } from '@heroui/react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { ITeacherAssignmentsIntake } from '@/entities/TeacherAssignment';
import { Svg } from '@/shared/ui/Svg';
import UserIcon from '@/shared/assets/icons/user.svg';
import { routerPath } from '@/shared/config/router';
import { COURSE_TYPE } from '@/shared/constants/courseData';
import styles from './TeacherIntakeAssignmentsCard.module.scss';

interface TeacherIntakeAssignmentsCardProps {
  intake: ITeacherAssignmentsIntake;
}

export const TeacherIntakeAssignmentsCard = ({ intake }: TeacherIntakeAssignmentsCardProps) => {
  const courseTypeLabel = COURSE_TYPE[intake.course.type] ?? COURSE_TYPE['masters-degree'];
  const to = `${routerPath.teacherAssignments}?courseType=${intake.course.type}&courseId=${intake.course.id}&intakeId=${intake.id}`;
  return (
    <Link to={to}>
      <div className={styles.wrapper}>
        <Chip
          className={cn('text-white bg-red', {
            ['bg-[#211D55]']: intake.course.type === 'short',
          })}
        >
          {courseTypeLabel}
        </Chip>
        <p className="text-lg font-medium line-clamp-2">
          {intake.course.title} {intake.title}
        </p>
        <div className={styles.line}></div>
        <div className="flex flex-row w-full justify-between">
          <p className={styles.text}>To be reviewed:</p>
          <p
            className={
              intake.assignmentsToReview > 0 ? styles.textDataWithIndicator : styles.textData
            }
          >
            {intake.assignmentsToReview > 0
              ? `${intake.assignmentsToReview} assignments`
              : '0 assignments'}
          </p>
        </div>
        <div className="flex flex-row w-full justify-between">
          <p className={styles.text}>Total students:</p>
          <p className={styles.textDataStudent}>{intake.totalStudents ?? 0} students</p>
        </div>
        <div className="flex flex-row w-full justify-between">
          <p className={styles.text}>Intake date:</p>
          <p className={styles.textDataStudent}>
            {format(new Date(intake.startDate), 'dd.MM.yyyy')}
          </p>
        </div>
        <div className={styles.line}></div>
        <div className="flex flex-row gap-2 items-center">
          <div className="flex flex-row gap-2 items-center min-w-fit">
            <Svg Icon={UserIcon} width={16} height={16} className="min-w-fit" />
            <p className="text-black text-sm font-bold min-w-fit leading-none">Academic staff:</p>
          </div>
          <p className="text-grey-secondary font-normal">
            {intake.course.leadTeacher?.username ?? 'Not assigned'}
          </p>
        </div>
      </div>
    </Link>
  );
};
